module.exports = __webpack_public_path__ + "static/img/RCV_g.1da3080d.png";